var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "80", height: "80", viewBox: "0 0 80 80", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "event-time-outline-icon"
    ),
    React.createElement(
      "g",
      { transform: "translate(24 24)", stroke: "#222", fill: "none", fillRule: "evenodd" },
      React.createElement("circle", { transform: "rotate(3 16 16)", cx: "16", cy: "16", r: "14.167" }),
      React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M16 8v9.519l7.135 6.028" })
    )
  );
});


// WEBPACK FOOTER //
// ../public/images/icons/time-outline.svg?react-svg